import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BrandOverlayActions } from "@youm-front/brand/data-access";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomBrandOverlayActions } from "../actions";
import {
  RoomBrandOverlayCreateRequestDTO,
  RoomBrandOverlayDeleteRequestDTO,
  RoomBrandOverlayUnUseRequestDTO,
  RoomBrandOverlayUseRequestDTO
} from "../dto";
import { RoomBrandOverlayService } from "../services";

@Injectable()
export class RoomBrandOverlayEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomBrandOverlayService: RoomBrandOverlayService
  ) {}

  roomBrandOverlayCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandOverlayActions.roomBrandOverlayCreate),
      switchMap((_) =>
        this.roomBrandOverlayService
          .roomBrandOverlayCreate(
            new RoomBrandOverlayCreateRequestDTO({
              roomId: _.roomBrandOverlayCreateVO.value.roomId,
              brandId: _.roomBrandOverlayCreateVO.value.brandId,
              data: _.roomBrandOverlayCreateVO.value.data,
              width: _.roomBrandOverlayCreateVO.value.width,
              height: _.roomBrandOverlayCreateVO.value.height
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandOverlayActions.roomBrandOverlayCreateSuccess({
                brandOverlay: _.data.brandOverlay
              }),
              BrandOverlayActions.brandOverlayCreateSuccess({
                brandOverlay: _.data.brandOverlay
              })
            ]),
            catchError((_: Error) => [
              RoomBrandOverlayActions.roomBrandOverlayCreateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandOverlayDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandOverlayActions.roomBrandOverlayDelete),
      switchMap((_) =>
        this.roomBrandOverlayService
          .roomBrandOverlayDelete(
            new RoomBrandOverlayDeleteRequestDTO({
              roomId: _.roomBrandOverlayDeleteVO.value.roomId,
              brandOverlay: _.roomBrandOverlayDeleteVO.value.brandOverlay
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandOverlayActions.roomBrandOverlayDeleteSuccess({
                brandOverlay: _.data.brandOverlay
              }),
              BrandOverlayActions.brandOverlayDeleteSuccess({
                brandOverlay: _.data.brandOverlay
              })
            ]),
            catchError((_: Error) => [
              RoomBrandOverlayActions.roomBrandOverlayDeleteFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandOverlayUnUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandOverlayActions.roomBrandOverlayUnUse),
      switchMap((_) =>
        this.roomBrandOverlayService
          .roomBrandOverlayUnUse(
            new RoomBrandOverlayUnUseRequestDTO({
              roomId: _.roomBrandOverlayUnUseVO.value.roomId,
              brandOverlay: _.roomBrandOverlayUnUseVO.value.brandOverlay
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandOverlayActions.roomBrandOverlayUnUseSuccess({
                brandOverlay: _.roomBrandOverlayUnUseVO.value.brandOverlay
              }),
              BrandOverlayActions.brandOverlayUnUseSuccess({
                brandOverlay: _.roomBrandOverlayUnUseVO.value.brandOverlay
              })
            ]),
            catchError((_: Error) => [
              RoomBrandOverlayActions.roomBrandOverlayUnUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandOverlayUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandOverlayActions.roomBrandOverlayUse),
      switchMap((_) =>
        this.roomBrandOverlayService
          .roomBrandOverlayUse(
            new RoomBrandOverlayUseRequestDTO({
              roomId: _.roomBrandOverlayUseVO.value.roomId,
              brandOverlay: _.roomBrandOverlayUseVO.value.brandOverlay
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandOverlayActions.roomBrandOverlayUseSuccess({
                brandOverlay: _.roomBrandOverlayUseVO.value.brandOverlay
              }),
              BrandOverlayActions.brandOverlayUseSuccess({
                brandOverlay: _.roomBrandOverlayUseVO.value.brandOverlay
              })
            ]),
            catchError((_: Error) => [
              RoomBrandOverlayActions.roomBrandOverlayUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );
}
